<template>
  <tbody class="ownership-info table center">
    <tr>
      <th colspan="10">业务所属</th>
    </tr>
    <tr>
      <td>收单机构</td>
      <td>
        <el-input v-model="details.companyName" readonly />
      </td>
      <td>服务商</td>
      <td>
        <el-input v-model="details.servicerName" readonly />
      </td>
      <td>拓展人员</td>
      <td colspan="5">
        <el-input v-model="details.expandUserName" readonly />
      </td>
    </tr>
    <!-- <slot></slot> -->
  </tbody>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      default() {
        return {}
      },
      comment: '详情信息'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/detailsTable.scss';
</style>